import { gql } from '@apollo/client';

export const CREATE_TRANSACTION = gql`
  mutation CreateTransaction($request: CreateTransactionRequest!) {
    CreateTransaction(request: $request) {
      id
    }
  }
`;

export const UPDATE_TRANSACTION = gql`
  mutation UpdateTransaction(
    $id: String!
    $request: UpdateTransactionRequest!
  ) {
    UpdateTransaction(id: $id, request: $request) {
      id
    }
  }
`;

export const DECLINE_TRANSACTION = gql`
  mutation DeclineTransaction(
    $id: String!
    $request: DeclineTransactionRequest!
  ) {
    DeclineTransaction(id: $id, request: $request) {
      id
    }
  }
`;

export const ACCEPT_TRANSACTION = gql`
  mutation AcceptTransaction(
    $id: String!
    $request: AcceptTransactionRequest!
  ) {
    AcceptTransaction(id: $id, request: $request) {
      id
    }
  }
`;

export const CREATE_TRANSACTION_FOR_USER = gql`
  mutation CreateTransactionForUser(
    $request: CreateTransactionForUserRequest!
  ) {
    CreateTransactionForUser(request: $request) {
      id
    }
  }
`;
